<template>
  <div class="header">
    <quantity
      :quantity="selectedFiles[0].quantity"
      @setQuantity="setQuantity"
      :editable="quantityEditable"
      :min-quantity="product.minQuantity"
      class="quantity"
    ></quantity>
    <price
      v-if="showPrice"
      class="price"
      :files="selectedFiles"
      :product="product"
    ></price>
    <div class="button-container" v-if="standalone">
      <cart-button :disabled="requiredMissing" @add-to-cart="$emit('add-to-cart')"></cart-button>
    </div>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useFileListStore } from '@/stores/FileList.store'
import Quantity from '@/components/ui/ProductQuantity.vue'
import Price from './Price.vue'
import CartButton from '@/components/ui/CartButton.vue'
import ProductOrderMixin from '@/features/productOrder/ProductOrderMixin'

export default {
  name: 'ProductSpecsHeader',
  mixins: [ProductOrderMixin],
  components: {
    Quantity,
    Price,
    CartButton
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    selectedFiles: {
      type: Array,
      required: true
    },
    standalone: {
      type: Boolean,
      default: false
    },
    requiredMissing: {
      type: Boolean,
      default: false
    }
  },
  emits: ['add-to-cart'],
  computed: {
    ...mapStores(useFileListStore),
    selectedFileNames() {
      return this.selectedFiles.map((file) => file.fileName)
    },
    showPrice() {
      if (this.product.hidePrice) {
        return false
      }

      return this.rootStore.theme.customFields.productOrder?.calculatePrice
    },
    quantityEditable() {
      // Quantity is niet aanpasbaar wanneer er een ADDRESS_LIST aanwezig is,
      // of wanneer het product zijn aantal uit de bestandsanalyse haalt
      const hasAddressList = this.selectedFiles[0].productSpecs.files?.some(
        (file) => file.type === 'ADDRESS_LIST'
      )
      return !hasAddressList && !this.hasQuantitySource(this.product)
    }
  },
  methods: {
    setQuantity(val) {
      this.fileListStore.updateProductOrderQuantity([
        this.selectedFileNames,
        val
      ])

      if (this.showPrice) {
        this.fileListStore.setProductOrderPrice({
          fileNames: this.selectedFileNames,
          spec: {},
          hydrate: false
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.header {
  padding: 0 0 15px 3px;
  display: flex;
  align-items: center;
}

.quantity {
  padding-right: 20px;
  flex: 0 0 auto;
}

.price {
  flex-grow: 1;
}

.button-container {
  flex: 0 1 210px;
  margin-left: auto;
}
</style>
